class Punchline {
  private el: HTMLElement;
  constructor(element: HTMLElement) {
    this.el = element;
    this.stringParser();
  }

  private stringParser = () => {
    let content = this.el.textContent;
    this.el.innerHTML = '';
    let result: any = content?.split('_');
    for (let i = 0; i < result.length; i++) {
      this.el.insertAdjacentHTML(
        'beforeend',
        `<span class="${i % 2 == 0 ? '' : 'text-secondary'}">
          ${result[i]}</span>
        <br>`,
      );
    }
  };
}

export default Punchline;
